export enum LesTemplateType {
    NietLineair = 0,
    Lineair = 1,
    Fixed = 2,
}
